
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CardInfo',
  props: {
    name: {
      type: String,
      required: true,
    },
    pokeid: {
      type: String,
      required: true,
    },
    poketype: {
      type: Array,
      required: true,
    },
  },
});
